export default defineNuxtRouteMiddleware(async (to) => {
  const config = useRuntimeConfig();
  const baseURL = config.public.ACV_LEGACY_DOMAIN;
  // Note: Remove this middleware when Infra is finished setting up a proper redirect
  if (to.path === '/tracking/tracking.php') {
    navigateTo(`${baseURL}tracking/tracking.php?id=${to.query?.id}`, {
      external: true,
    });
    return abortNavigation();
  }

  /**
   * A cURL request is currently made to legacy load board.
   * This a temporary work around until Infra sorts it out
   */
  if (to.path === '/cron/transport_cron.php') {
    useFetch(`${baseURL}cron/transport_cron.php`, {
      method: 'POST',
    });
    return abortNavigation();
  }
});
